// Or cross browser document ready:
// https://www.competa.com/blog/cross-browser-document-ready-with-vanilla-javascript/
// Native fadeOut
function fadeOut(el, ms) {
    if (ms) {
        el.style.transition = "opacity "+ms+"ms";
        el.addEventListener(
            'transitionend',
            function (event) {
                el.style.display = 'none';
            },
            false
        );
    }
    el.style.opacity = '0';
}

// Native fadeIn
function fadeIn(elem, ms) {
    elem.style.opacity = 0;

    if (ms) {
        let opacity = 0;
        const timer = setInterval(function () {
            opacity += 50 / ms;
            if (opacity >= 1) {
                clearInterval(timer);
                opacity = 1;
            }
            elem.style.opacity = opacity;
        }, 50);
    } else {
        elem.style.opacity = 1;
    }
}

function fadeToggle(elem, ms) {
    elem.style.transition = "opacity 3000ms";
    const { opacity } = elem.ownerDocument.defaultView.getComputedStyle(elem, null);
    if (opacity === "1") {
        elem.style.opacity = "0";
    } else {
        elem.style.opacity = "1";
    }
}
